var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"slot":"main"},slot:"main"},[_c('v-row',[_c('h3',[_vm._v("Client List View")])]),_c('v-row',[_vm._v(_vm._s(_vm.$router.params))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }